import React from "react";
import "../styles/scss/Spinner.scss";

export const Spinner = ({ size = "regular" }) => (
  <div className={`spinner ${size}`}></div>
);
